import { useQuery } from '@tanstack/react-query';
import { teamsService } from '../services/teamsService';

/**
 * Hook to fetch members assigned to a team
 *
 * @param teamId - Team ID to fetch members for
 * @returns React Query result with members data
 *
 * @example
 * const { data: members, isLoading } = useTeamMembers(teamId);
 */
export const useTeamMembers = (teamId: string | undefined) => {
  return useQuery({
    queryKey: ['team-members', teamId],
    queryFn: () => teamsService.getTeamMembers(teamId!),
    enabled: !!teamId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
